import {valuesGridStyles, valueTitleStyles, statsGridStyles, statItemStyles, statNumberStyles, statLabelStyles, timelineStyles, timelineItemStyles, timelineYearStyles, timelineContentStyles, timelineEventStyles, timelineDescStyles,    teamImageStyles, sectionTitleStyles, teamBioStyles, teamCardStyles, teamGridStyles, teamContentStyles, teamNameStyles, teamPositionStyles, imageStyles, valuesTitleStyles, valueDescStyles, valueIconStyles, valueCardStyles, aboutGridStyles, aboutTextStyles, aboutDescStyles, aboutImageStyles,  loadingStyles, readMoreButtonStyles, pageHeaderSubStyles, pageHeaderTitleStyles, pageHeaderStyles, sectionStyles, containerStyles} from './styles';

const AboutPage = () => {
  // Team members data
  const teamMembers = [
    {
      name: "Dr. Sarah Al-Rashid",
      position: "Executive Director",
      bio: "Former Saudi Ministry of Investment advisor with 15+ years in international trade relations.",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      name: "James Thompson",
      position: "UK Relations Director", 
      bio: "Former British Trade Commissioner with extensive experience in Middle East markets.",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      name: "Ahmed Al-Mahmoud",
      position: "Business Development Lead",
      bio: "Entrepreneur and investor connecting Saudi startups with UK venture capital.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      name: "Emily Richardson",
      position: "Events & Communications",
      bio: "Former diplomat specializing in cultural exchange and business networking events.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    }
  ];

  const milestones = [
    { year: "2019", event: "Network Established", description: "Founded to strengthen Saudi-UK business relations" },
    { year: "2020", event: "First Virtual Summit", description: "Adapted to digital format, reaching 1000+ participants" },
    { year: "2021", event: "500+ Members", description: "Crossed milestone of 500 active network members" },
    { year: "2022", event: "Investment Forum", description: "Facilitated $500M+ in bilateral investments" },
    { year: "2023", event: "Cultural Exchange", description: "Launched cultural and educational exchange programs" },
    { year: "2024", event: "Tech Innovation Hub", description: "Established joint technology innovation initiatives" }
  ];

  return (
    <div>
      {/* Page Header */}
      <section style={pageHeaderStyles}>
        <div style={containerStyles}>
          <h1 style={pageHeaderTitleStyles}>About Saudi British Network</h1>
          <p style={pageHeaderSubStyles}>
            Building bridges between Saudi Arabia and the United Kingdom through meaningful connections, 
            shared opportunities, and cultural understanding.
          </p>
        </div>
      </section>

      {/* Mission & Vision */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          <div style={aboutGridStyles}>
            <div style={aboutTextStyles}>
              <h2 style={sectionTitleStyles}>Our Mission</h2>
              <p style={aboutDescStyles}>
                To create a thriving ecosystem that connects Saudi and British professionals, entrepreneurs, 
                and organizations, fostering collaboration, innovation, and mutual prosperity between our nations.
              </p>
              <p style={aboutDescStyles}>
                We believe that strong bilateral relationships are built on trust, understanding, and shared values. 
                Our network serves as the catalyst for meaningful partnerships that drive economic growth and 
                cultural exchange.
              </p>
            </div>
            <div style={aboutImageStyles}>
              <img 
                src="https://saudigazette.com.sa/uploads/images/2018/03/08/750992.jpg" 
                alt="Team collaboration" 
                style={imageStyles}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section style={{...sectionStyles, backgroundColor: '#f8f9fa'}}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Our Values</h2>
          <div style={valuesGridStyles}>
            <div style={valueCardStyles}>
              <div style={valueIconStyles}>🤝</div>
              <h3 style={valueTitleStyles}>Collaboration</h3>
              <p style={valueDescStyles}>
                Building bridges between cultures, industries, and individuals to create lasting partnerships.
              </p>
            </div>
            <div style={valueCardStyles}>
              <div style={valueIconStyles}>💡</div>
              <h3 style={valuesTitleStyles}>Innovation</h3>
              <p style={valueDescStyles}>
                Fostering creative solutions and technological advancement through cross-border collaboration.
              </p>
            </div>
            <div style={valueCardStyles}>
              <div style={valueIconStyles}>🎯</div>
              <h3 style={valuesTitleStyles}>Excellence</h3>
              <p style={valueDescStyles}>
                Maintaining the highest standards in all our initiatives and member services.
              </p>
            </div>
            <div style={valueCardStyles}>
              <div style={valueIconStyles}>🌍</div>
              <h3 style={valuesTitleStyles}>Global Impact</h3>
              <p style={valueDescStyles}>
                Creating positive change that extends beyond our network to benefit both nations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section style={sectionStyles}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Our Leadership Team</h2>
          <div style={teamGridStyles}>
            {teamMembers.map((member, index) => (
              <div key={index} style={teamCardStyles}>
                <img src={member.image} alt={member.name} style={teamImageStyles} />
                <div style={teamContentStyles}>
                  <h3 style={teamNameStyles}>{member.name}</h3>
                  <p style={teamPositionStyles}>{member.position}</p>
                  <p style={teamBioStyles}>{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Timeline Section */}
      {/* <section style={{...sectionStyles, backgroundColor: '#f8f9fa'}}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Our Journey</h2>
          <div style={timelineStyles}>
            {milestones.map((milestone, index) => (
              <div key={index} style={timelineItemStyles}>
                <div style={timelineYearStyles}>{milestone.year}</div>
                <div style={timelineContentStyles}>
                  <h3 style={timelineEventStyles}>{milestone.event}</h3>
                  <p style={timelineDescStyles}>{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Statistics */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Network Impact</h2>
          <div style={statsGridStyles}>
            <div style={statItemStyles}>
              <h3 style={statNumberStyles}>300+</h3>
              <p style={statLabelStyles}>Active Members</p>
            </div>
            <div style={statItemStyles}>
              <h3 style={statNumberStyles}>10+</h3>
              <p style={statLabelStyles}>Partner Organizations</p>
            </div>
            <div style={statItemStyles}>
              <h3 style={statNumberStyles}>4+</h3>
              <p style={statLabelStyles}>Annual Events</p>
            </div>
            {/* <div style={statItemStyles}>
              <h3 style={statNumberStyles}>£2.5B+</h3>
              <p style={statLabelStyles}>Deals Facilitated</p>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};
export default AboutPage;